var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"border":"1px solid #414142","height":"100pt","opacity":"0.3"}},[_c('p',{staticStyle:{"display":"block","margin-top":"85pt","margin-left":"40pt"}},[_vm._v("COURT STAMP")])])
}]

export { render, staticRenderFns }